import React, { PureComponent } from 'react'
import RavenJS from 'raven-js'
import ErrorBoundaryComponent from './ErrorBoundaryComponent'

export default class RavenWrapper extends PureComponent {
  componentWillMount () {
    const {
      config,
      version,
      environment
    } = this.props

    RavenJS.config(
      config.dsn,
      Object.assign({}, config, { environment, release: version })
    ).install()

    if (RavenJS._isRavenInstalled) {
      window.addEventListener('resize', () => this.setViewportTag())
      this.setViewportTag()
    }
  }

  componentWillUnmount () {
    if (RavenJS._isRavenInstalled) {
      RavenJS.uninstall()
    }
  }

  setViewportTag () {
    RavenJS.setExtraContext({
      viewport: `${window.innerWidth}x${window.innerHeight}`
    })
  }

  render () {
    return (
      <ErrorBoundaryComponent widgetName='Layout'>
        { this.props.children }
      </ErrorBoundaryComponent>
    )
  }
}
